/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  containerPadding: {
    padding: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '16px',
    },
  },
  representativeTitleAndActionsHolder: {
    display: 'flex',
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },

  representativeTitle: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
    '& > span': {
      display: 'block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
  },

  representativeGridContainer: {},

  representativeDocumentsTitle: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    padding: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '16px',
    },
  },

  documentsHolder: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },
});

export default styles;
